import React, { useContext, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import SwatchVariantsRadio from './SwatchVariantsRadio';
import { RadioContext } from '../../../shared/components/AriaRadio/RadioGroup';

const SwatchVariantsRadioGroup = function SwatchVariantsRadioGroupComponent({ swatch, pendingRequest }) {
  const state = useContext(RadioContext);
  const didMount = useRef(false);
  
  useEffect(() => {
    if (!didMount.current) {
      didMount.current = true;
      return;
    }

    const variation = swatch.find((variation) => variation.value === state.selectedValue);

    variation.action();
  }, [state.selectedValue]);

  return (
    <>
      {swatch.map((variation) => (
        <SwatchVariantsRadio 
          key={variation.value} 
          blocked={pendingRequest && state.selectedValue != variation.value}
          {...variation} 
        />
      ))}
    </>
  );
}

SwatchVariantsRadioGroup.propTypes = {
  swatch: PropTypes.array.isRequired,
  pendingRequest: PropTypes.bool.isRequired,
};

export default SwatchVariantsRadioGroup;
